import {LANGUAGE} from '@/common/utils/constants';

export const FORMS_NOTIFICATIONS = {
	[LANGUAGE.en.short]: {
		somethingWentWrong: "Something went wrong",
		projectSuccessfullySaved: "Your project was successfully saved.",
		cantFindProjectWithId: "Couldn't find project with this id",
		projectStepWasSuccessfullyUpdated: "Project step was successfully updated",
		someFieldsDontMatchValidations: "Some fields don't match their validations. Please edit them in order to save your project",
		projectWasSuccessfullyUpdated: "Project was successfully updated",
		someProjectAttributesRequireApproval: "Some project attributes still require Approval from CMT. Project cannot transition with attributes still waiting for approval",
		validationsFromSwalMessage: {
			title: "Are you sure?",
			text: "Any changes you've made will be lost",
			deny: "Go Back",
			confirm: "Continue"
		},
		managementFormSwalMessage: {
			title: "Are you sure?",
			text: "Any changes you've made will be lost",
			deny: "Go Back",
			confirm: "Continue"
		},
		toolCertificateDeletedSuccessfully: "Tool/Certificate deleted successfully",
		imageMayBeBad: "The uploaded image does not meet the requirements. Please check the guide.",
		successCreatedQualificationAttribute: 'Successfully created',
		successUpdatedQualificationAttribute: 'Successfully updated',
		tool: 'tool',
		certificate: 'certification',
		duplicateToolCertificate: 'Tool/Certificate already exists',
	},
	[LANGUAGE.it.short]: {
		somethingWentWrong: "Qualcosa è andato storto",
		projectSuccessfullySaved: "Il tuo progetto è stato salvato con successo.",
		cantFindProjectWithId: "Non sono riuscito a trovare il progetto con questo ID",
		projectStepWasSuccessfullyUpdated: "Lo step del progetto è stato aggiornato con successo",
		someFieldsDontMatchValidations: "Alcuni campi non corrispondono alle loro validazioni. Modificali per salvare il tuo progetto",
		projectWasSuccessfullyUpdated: "Il progetto è stato aggiornato con successo",
		someProjectAttributesRequireApproval: "Alcuni attributi del progetto richiedono ancora l'approvazione da parte di CMT. Il progetto non può passare con gli attributi in attesa di approvazione",
		validationsFromSwalMessage: {
			title: "Sei sicuro?",
			text: "Qualsiasi modifica che hai apportato andrà perso",
			deny: "Torna indietro",
			confirm: "Continua"
		},
		managementFormSwalMessage: {
			title: "Sei sicuro?",
			text: "Qualsiasi modifica che hai apportato andrà perso",
			deny: "Torna indietro",
			confirm: "Continua"
		},
		toolCertificateDeletedSuccessfully: "Strumento / certificato eliminato con successo",
		imageMayBeBad: "L'immagine caricata potrebbe non soddisfare i requisiti. Si prega di controllare la guida.",
		successCreatedQualificationAttribute: 'Creato con successo',
		successUpdatedQualificationAttribute: 'Aggiornato con successo',
		tool: 'attrezzo',
		certificate: 'certificazione'
	},
	[LANGUAGE.de.short]: {
		somethingWentWrong: "Etwas ist schief gelaufen",
		projectSuccessfullySaved: "Ihr Projekt wurde erfolgreich gespeichert.",
		cantFindProjectWithId: "Konnte ein Projekt mit dieser ID nicht finden",
		projectStepWasSuccessfullyUpdated: "Projektschritt wurde erfolgreich aktualisiert",
		someFieldsDontMatchValidations: "Einige Felder entsprechen nicht ihren Validierungen. Bitte bearbeiten Sie sie, um Ihr Projekt zu speichern",
		projectWasSuccessfullyUpdated: "Projekt wurde erfolgreich aktualisiert",
		someProjectAttributesRequireApproval: "Einige Projektattribute erfordern noch die Genehmigung von CMT. Das Projekt kann nicht mit Attributen übergangsweise genehmigt werden",
		validationsFromSwalMessage: {
			title: "Bist du dir sicher?",
			text: "Alle Änderungen, die Sie vorgenommen haben, werden verloren gehen",
			deny: "Geh zurück",
			confirm: "Fortsetzen"
		},
		managementFormSwalMessage: {
			title: "Bist du dir sicher?",
			text: "Alle Änderungen, die Sie vorgenommen haben, werden verloren gehen",
			deny: "Geh zurück",
			confirm: "Fortsetzen"
		},
		toolCertificateDeletedSuccessfully: "Tool / Zertifikat erfolgreich gelöscht",
		imageMayBeBad: "Das hochgeladene Bild entspricht nicht den Anforderungen. Bitte überprüfen Sie die Anleitung.",
		successCreatedQualificationAttribute: 'Erfolgreich erstellt',
		successUpdatedQualificationAttribute: 'Erfolgreich aktualisiert',
		tool: 'Werkzeug',
		certificate: 'Zertifizierung'
	},
	[LANGUAGE.fr.short]: {
		somethingWentWrong: "Quelque chose s'est mal passé",
		projectSuccessfullySaved: "Votre projet a été sauvé avec succès.",
		cantFindProjectWithId: "Impossible de trouver un projet avec cet identifiant",
		projectStepWasSuccessfullyUpdated: "L'étape du projet a été mise à jour avec succès",
		someFieldsDontMatchValidations: "Certains champs ne correspondent pas à leurs validations. Veuillez les modifier afin d'enregistrer votre projet",
		projectWasSuccessfullyUpdated: "Le projet a été mis à jour avec succès",
		someProjectAttributesRequireApproval: "Certains attributs de projet nécessitent toujours l'approbation de CMT. Le projet ne peut pas passer avec des attributs en attente d'approbation",
		validationsFromSwalMessage: {
			title: "Êtes-vous sûr?",
			text: "Toutes les modifications que vous avez apportées seront perdues",
			deny: "Retourner",
			confirm: "Continuer"
		},
		managementFormSwalMessage: {
			title: "Êtes-vous sûr?",
			text: "Toutes les modifications que vous avez apportées seront perdues",
			deny: "Retourner",
			confirm: "Continuer"
		},
		toolCertificateDeletedSuccessfully: "Outil / certificat supprimé avec succès",
		imageMayBeBad: "L'image téléchargée ne répond pas aux exigences. Veuillez vérifier le guide.",
		successCreatedQualificationAttribute: 'Création réussie',
		successUpdatedQualificationAttribute: 'Mise à jour réussie',
		tool: 'outil',
		certificate: 'attestation'
	},
	[LANGUAGE.ja.short]: {
		somethingWentWrong: "何かがうまくいかなかった",
		projectSuccessfullySaved: "あなたのプロジェクトは正常に保存されました。",
		cantFindProjectWithId: "このIDでプロジェクトが見つかりませんでした",
		projectStepWasSuccessfullyUpdated: "プロジェクトステップが正常に更新されました",
		someFieldsDontMatchValidations: "一部のフィールドは、その検証に一致しません。プロジェクトを保存するには、それらを編集してください",
		projectWasSuccessfullyUpdated: "プロジェクトは正常に更新されました",
		someProjectAttributesRequireApproval: "プロジェクトの一部の属性は、引き続きCMTの承認を必要としています。プロジェクトは、承認待ちの属性があるままでは遷移できません",
		validationsFromSwalMessage: {
			title: "本気ですか？",
			text: "あなたが行った変更は失われます",
			deny: "戻る",
			confirm: "継続する"
		},
		managementFormSwalMessage: {
			title: "本気ですか？",
			text: "あなたが行った変更は失われます",
			deny: "戻る",
			confirm: "継続する"
		},
		toolCertificateDeletedSuccessfully: "ツール/証明書が正常に削除されました",
		imageMayBeBad: "アップロードされた画像が要件を満たしていない可能性があります。ガイドを確認してください。",
		successCreatedQualificationAttribute: '正常に作成されました',
		successUpdatedQualificationAttribute: '正常に更新されました',
		tool: '道具',
		certificate: '認証'
	},
	[LANGUAGE.es.short]: {
		somethingWentWrong: "Algo salió mal",
		projectSuccessfullySaved: "Tu proyecto se ha guardado correctamente.",
		cantFindProjectWithId: "No se pudo encontrar un proyecto con este ID",
		projectStepWasSuccessfullyUpdated: "El paso del proyecto se actualizó correctamente",
		someFieldsDontMatchValidations: "Algunos campos no coinciden con sus validaciones. Por favor, edítalos para guardar tu proyecto",
		projectWasSuccessfullyUpdated: "El proyecto se actualizó correctamente",
		someProjectAttributesRequireApproval: "Algunos atributos del proyecto aún requieren aprobación de CMT. El proyecto no puede transitar con atributos que aún esperan aprobación",
		validationsFromSwalMessage: {
			title: "¿Estás seguro?",
			text: "Cualquier cambio que hayas realizado se perderá",
			deny: "Volver atrás",
			confirm: "Continuar"
		},
		managementFormSwalMessage: {
			title: "¿Estás seguro?",
			text: "Cualquier cambio que hayas realizado se perderá",
			deny: "Volver atrás",
			confirm: "Continuar"
		},
		toolCertificateDeletedSuccessfully: "Herramienta / certificado eliminado correctamente",
		imageMayBeBad: "La imagen cargada no cumple con los requisitos. Por favor, revisa la guía.",
		successCreatedQualificationAttribute: 'Creación exitosa',
		successUpdatedQualificationAttribute: 'Actualización exitosa',
		tool: 'herramienta',
		certificate: 'certificación'
	}
};
